export const declOfNum = (n, textForms) => {
  n = Math.abs(n) % 100
  let n1 = n % 10
  if (n > 10 && n < 20) { return textForms[2] }
  if (n1 > 1 && n1 < 5) { return textForms[1] }
  if (n1 === 1) { return textForms[0] }
  return textForms[2]
}

/**
 * @param {Date} date
 */
export const formatDate = (date) => {
  return date.getDate().toString().padStart(2, '0') + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getFullYear()
}



// WEBPACK FOOTER //
// ./src/utils/time.js